import apiFetch from '../apiFetch'

export default function (token) {    
  return apiFetch({endPoint: `Analisis/getUrlPIC`, method: 'POST', token: token})
}
